import React from "react";
import icons from "../../../../../assets/images/icons";
import styles from "./ChatMessage.module.scss";

export default function OpponentAvatar({ grouped, avatarUrl }) {
  if (grouped) {
    return <div className={styles.avatarSpacer} aria-hidden />;
  }
  return (
    <div className={styles.avatarWrap}>
      {avatarUrl ? (
        <img src={avatarUrl} alt="" className={styles.avatar} width={40} height={40} />
      ) : (
        <div className={styles.avatarPlaceholder} aria-hidden>
          <img
            src={icons.messager?.person}
            alt=""
            className={styles.avatarPlaceholderImg}
            width={24}
            height={24}
          />
        </div>
      )}
    </div>
  );
}
